import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RoutingService } from './routing.service';

@Injectable({
  providedIn: 'root'
})
export class NavigatesearchService {

  private core_Url = environment.triportCoreService.url + environment.triportCoreService.apiVersion;
  public searchText !: string;
  private SearchStringSubject = new Subject<string>();
  constructor(private http: HttpClient, private routeService: RoutingService) { }
  //{sponsorName}/{portalId}
  Search(portalID : number, search : string){
    return new Promise((resolve, reject) => {
      lastValueFrom(this.http.post(this.core_Url + "Search/" + this.routeService.getSponsorName() + "/" + portalID, JSON.stringify(search)))
        .then(
          (response?: any) => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  // getSearchString() {
  //   return this.searchText;
  // }
  // setSearchString(searchText: string) {
  //   this.searchText = searchText;
  // }
  setSearchString(searchText: string) {
    this.SearchStringSubject.next(searchText);
  }

  getSearchString(): Observable<string> {
    return this.SearchStringSubject.asObservable();
  }
}
